import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ContactPage from './pages/ContactPage';
import FootballIQTest from './pages/FootballIQTest';
import AssessmentPage from './pages/AssessmentPage';
import ScholarshipPage from './pages/ScholarshipPage';
import WaiverPage from './pages/WaiverPage';
import Navigation from './components/Navigation';

function App() {
  return (
    <Router>
      <div className="App">
        <Navigation />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/assessment" element={<AssessmentPage />} />
          <Route path="/football-iq-test" element={<FootballIQTest />} />
          <Route path="/scholarship" element={<ScholarshipPage />} />
          <Route path="/waiver" element={<WaiverPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
